import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ModalService } from 'src/app/shared/components/modal/modal.service';

@Component({
	selector: 'app-pin-modal',
	templateUrl: './pin.modal.component.html'
})
export class PinModalComponent implements OnInit {
	changePin = false;
	pin = '';
	message = ''
	pinCount = 0;
	confirmPin = ''
	member: any = {}
	error = false;
	loading = false;
	title = 'Enter Your Pin'

	@ViewChild('modalComponent') modal: | ModalComponent<PinModalComponent> | undefined;

	onComplete = async (pin: string) => { };

	constructor(
		private modalService: ModalService<PinModalComponent>,
		private fns: AngularFireFunctions
	) { }
	clientRequest = this.fns.httpsCallable('clientRequest');
	ngOnInit(): void {
		const data = this.modalService.getData();
		if (data) {
			this.onComplete = data.onComplete;
			this.changePin = data.changePin;
			this.message = data.message;
			this.member = data.member;
		}
		if (!this.member.pinNumber) {
			this.changePin = true;
			this.title='Set Your Pin';
			this.message='Enter Your new Pin'
		}
	}

	async concatPin(character: string) {
		this.pin.length<4 ? this.pin += character:null;
		this.error=false;
		if (this.pin.length == 4) {
			if(this.changePin ){
				if(this.pinCount==0){
					this.title='Confirm your pin'
					this.confirmPin=this.pin;
					this.pin=''
					this.pinCount=1;
				}else{
					this.loading=true;
					this.pinCount=0
					this.setPin();
					
				}
			}else{	
			this.submit();
			}
			
		}
	};

	setPin = async () => {

		if (this.pin === this.confirmPin) {
			const result = await this.clientRequest({ request: "setPin", data: { pin: this.pin, confirmPin: this.confirmPin, memberDocId: this.member.docId } }).toPromise()
			this.submit()
		} else {
			this.title = 'Pins did not match'
			this.error = true;
			this.loading = false;
			this.pin=''

		}

	}
	deleteChar() {
		if(this.pin.length!==4){
			this.pin = this.pin.slice(0, -1)
		}
		
	}

	async submit(): Promise<void> {
		this.error=false;
		this.loading = true;
		try {
			await this.onComplete(this.pin);
			await this.close();
		} catch (error:any) {
			console.error(error)
			this.error=true;
			this.message= error?.message ||'An error occured try again'
			this.title='OOPS!'
			this.loading=false;
			this.pin=''
		}
		

		
	}

	async close(): Promise<void> {
		console.log(this.modal)
		await this.modal?.close();
	}
}
